enum ServicePartnerPrice {
  INCLUDED = 'included',
  EXCLUDED = 'excluded',
}

export { ServicePartnerPrice }
